import { useEffect, useState } from "react";
import { getPosts } from "../rest/RestAPI";
import ArticlePlaceholder from "./ArticlePlaceholder";
import NewsItem from "./NewsItem";

export default function News() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
  async function fetchPosts() {
    const res = await getPosts();
    setPosts(res);
  }
  fetchPosts();
  }, []);
    return (
      <div className='News'>
        <div className='home2'>
        {posts.map(post => {
            return <NewsItem key={post.id} post={post}/>
        })}
        
        </div>
      </div>
    );
  }